



























































import { Vue, Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {},
  computed: {
    ...mapState('Business', {
      business: 'business',
      allBusinesses: 'allBusinesses',
    }),
  },
})
export default class BusinessUpdateReferralBusiness extends Vue {
  business!: Model;
  isMounted = false;
  isLoading = false;
  isApiFetch = {
    isApiFetchBusinessFinished: false,
    isApiFetchAllBusinessedFinished: false,
  };

  referralBusinessOid = null;

  beforeMount() {
    this.$store
      .dispatch('Business/fetch', {
        businessOid: this.$route.params.businessOid,
        config: {
          params: {
            expand: [
              'business_contacts',
              'business_addresses',
              'billing_address',
              'billing_contact',
              'postal_address',
              'primary_contact',
              'director_contact',
              'referred_businesses',
              'referral_business',
            ],
          },
        },
      })
      .then(() => {
        this.referralBusinessOid = this.business.referral_business?.object_id;
        this.isApiFetch['isApiFetchBusinessFinished'] = true;
      });

    this.$store.dispatch('Business/all').then(() => {
      this.isApiFetch['isApiFetchAllBusinessedFinished'] = true;
    });
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (isFinished) {
        this.isMounted = true;
      }
    }
  }

  referral() {
    this.isLoading = true;
    this.$store
      .dispatch('Business/referralBusiness', {
        businessOid: this.$route.params.businessOid,
        config: {
          referral_business_oid: this.referralBusinessOid,
        },
      })
      .then(() => {
        this.isLoading = false;
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: this.$i18n.t('common_word.success_update'),
        });
      });
  }
}
